import { Page, Pagebar, PagebarTitle } from '@monorepo/base/src/components/page/page';
import { useStores } from '@monorepo/controlled/src/hooks/use-stores';
import { observer } from 'mobx-react';
import { IAdminxStore } from '../../../../modules/stores';
import { ControlledTable } from '@monorepo/controlled/src/components/table-wrapper/table-wrapper';
import { useRoute } from '../../../../modules/hooks/tools/use-route';
import { useStateBetweenPages } from '../../../../modules/hooks/tools/use-state-between-pages';
import { useList } from '../../../../modules/hooks/tools/use-list';
import { TrafficEntityModel } from '../../../../modules/models/traffic-entity.model';
import { useBidderTrafficHeaders } from '../../../../modules/hooks/theaders/bidder-traffic.headers';
import { usePageSettings } from '@monorepo/tools/src/lib/hooks/tools/use-page-settings';
import routes from '../../../../modules/routes/index.routes';
import { sortData } from '../../../../modules/hooks/tools/use-merge-with-performance';
import { useBidderTrafficActions } from '../../../../modules/hooks/actions/bidder-traffic.actions';

export const BidderTraffic = observer(() => {
	const {
		bidderStore: { trafficList },
	} = useStores<IAdminxStore>();

	const { currentRouteWithoutSpecialChars } = useRoute();
	const sortBy = usePageSettings().tableStore?.getSortingBy();
	const stateBetweenPages = useStateBetweenPages(() => trafficList.getList().length !== 0);

	useList<TrafficEntityModel>(trafficList, undefined, stateBetweenPages);

	const { columns } = useBidderTrafficHeaders();
	const { FiltersActions } = useBidderTrafficActions();
	const sorted = sortData(trafficList.getList().slice(), sortBy?.[0]);

	return (
		<Page>
			<Pagebar>
				<PagebarTitle>Traffic</PagebarTitle>
			</Pagebar>

			<ControlledTable
				currentRoute={currentRouteWithoutSpecialChars}
				createRoute={routes.bidder.createTraffic()}
				columns={columns}
				data={sorted}
				defaultSortBy={sortBy}
				isLoading={trafficList.getIsLoading()}>
				{() => ({ FiltersActions })}
			</ControlledTable>
		</Page>
	);
});
